module.exports = __webpack_public_path__ + "static/media/2Anniversary.4ac3cdf0.png";